import { Text, Stack } from '@mantine/core';

const TextPriceWithDiscount = ({ size, fontWeight, price, discountedPrice, priceComunityUAI, isComunidad }) => {
  const toNumber = (value) => {
    if (value === null || value === undefined) return 0;
    if (typeof value === 'number') return value;
    // Quitar separadores y usar coma como decimal si existiera
    const normalized = String(value).replace(/\./g, '').replace(',', '.');
    const parsed = parseFloat(normalized);
    return isNaN(parsed) ? 0 : parsed;
  };

  const formatPrice = (value) => {
    const numberValue = toNumber(value);
    return numberValue.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Normalizar para comparar correctamente
  const p = toNumber(price);
  const d = toNumber(discountedPrice);
  const c = toNumber(priceComunityUAI);

  // isComunidad viene del estado real (knownUser.comunity + precio comunidad presente).
  // Antes se decidia por "?token" en la URL: un token vencido mostraba comunidad sin serlo.
  // Ademas c puede ser 0 legitimamente (bonificacion del 100%), por eso no se usa "c > 0".
  const isKnownUser = !!isComunidad;
  const areEqual = (a, b) => Math.abs(a - b) < 0.005; // tolerancia al centavo

  // Caso 1: si precio original y descuento son iguales (externo), mostrar solo un precio
  if (!isKnownUser && areEqual(p, d)) {
    return (
      <Text size={size} fw={fontWeight}>{`$${formatPrice(d)}`}</Text>
    );
  }

  // Caso 2: si es miembro y el precio de comunidad es igual al descuento normal, mostrar una sola vez el final
  if (isKnownUser && areEqual(c, d)) {
    return (
      <div>
        {/* Mantenemos el original tachado si es distinto al final, para dar contexto */}
        {!areEqual(p, c) && (
          <Text 
            size={size} 
            fw={fontWeight}
            style={{ textDecoration: 'line-through', color: '#999', fontSize: size === 'lg' ? '14px' : '12px' }}
          >
            {`$${formatPrice(p)}`}
          </Text>
        )}
        <Text 
          size={size} 
          fw={fontWeight}
          style={{ color: '#f20a61', fontSize: size === 'lg' ? '16px' : '14px' }}
        >
          {`$${formatPrice(c)}`}
        </Text>
      </div>
    );
  }

  // Caso general
  return (
    <div>
      <div 
        style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
      >
        {/* Precio original tachado */}
        {!areEqual(p, d) && (
          <Text 
            size={size} 
            fw={fontWeight}
            style={{ textDecoration: 'line-through', color: '#999', fontSize: size === 'lg' ? '14px' : '12px' }}
          >
            {`$${formatPrice(p)}`}
          </Text>
        )}

        {/* Si es miembro UAI y hay diferencia entre precio normal y comunidad, mostrar el normal tachado */}
        {isKnownUser && !areEqual(c, d) && (
          <Text 
            size={size} 
            fw={fontWeight}
            style={{ textDecoration: 'line-through', color: '#999', fontSize: size === 'lg' ? '14px' : '12px' }}
          >
            {`$${formatPrice(d)}`}
          </Text>
        )}

        {/* Precio final */}
        <Text 
          size={size} 
          fw={fontWeight}
          style={{ color: '#f20a61', fontSize: size === 'lg' ? '16px' : '14px' }}
        >
          {`$${formatPrice(isKnownUser ? c : d)}`}
        </Text>

        {/* Texto de descuento comunidad UAI */}
        {isKnownUser && !areEqual(c, d) && (
          <Text size="xs" style={{ color: '#f20a61', fontWeight: 500 }}>
            Descuento exclusivo comunidad UAI
          </Text>
        )}
      </div>
    </div>
  );
};

export default TextPriceWithDiscount;